
import { Client } from "@/types/lead.types";

// Initial mock data for clients with client types
export const initialClients: Client[] = [
  {
    id: 'C001',
    name: 'Alexandre Dupont',
    email: 'alex.dupont@example.com',
    phone: '+212 6 23 45 67 89',
    status: 'Vendu',
    source: 'Site web',
    createdAt: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000),
    clientSince: new Date(Date.now() - 45 * 24 * 60 * 60 * 1000),
    accountManager: 'Yasmine Alaoui',
    nextAction: 'Suivi post-achat',
    clientType: 'Acheteur',
    interestedProperty: 'Villa moderne à Marrakech',
  },
  {
    id: 'C002',
    name: 'Marie Leclerc',
    email: 'marie.leclerc@example.com',
    phone: '+212 6 34 56 78 90',
    status: 'Vendu',
    source: 'Référence',
    createdAt: new Date(Date.now() - 90 * 24 * 60 * 60 * 1000),
    clientSince: new Date(Date.now() - 60 * 24 * 60 * 60 * 1000),
    accountManager: 'Mohammed Tazi',
    nextAction: 'Mise à jour du bien',
    clientType: 'Investisseur',
    investmentCriteria: 'Projets immobiliers à haut rendement',
  },
  {
    id: 'C003',
    name: 'Jean Moreau',
    email: 'jean.moreau@example.com',
    phone: '+212 6 78 90 12 34',
    status: 'Contacté',
    source: 'Formulaire Investir',
    createdAt: new Date(Date.now() - 20 * 24 * 60 * 60 * 1000),
    clientSince: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000),
    accountManager: 'Yasmine Alaoui',
    nextAction: 'Présentation des opportunités',
    clientType: 'Investisseur',
    investmentCriteria: 'Projets résidentiels à Casablanca, 500K-1M MAD',
  },
  {
    id: 'C004',
    name: 'Sophie Martin',
    email: 'sophie.martin@example.com',
    phone: '+212 6 45 67 89 01',
    status: 'Qualifié',
    source: 'Formulaire d\'offre',
    createdAt: new Date(Date.now() - 15 * 24 * 60 * 60 * 1000),
    clientSince: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
    accountManager: 'Mohammed Tazi',
    nextAction: 'Visite de propriété',
    clientType: 'Acheteur',
    interestedProperty: 'Appartement de luxe à Rabat',
  },
  {
    id: 'C005',
    name: 'Pierre Lambert',
    email: 'pierre.lambert@example.com',
    phone: '+212 6 56 78 90 12',
    status: 'Contacté',
    source: 'Newsletter',
    createdAt: new Date(Date.now() - 10 * 24 * 60 * 60 * 1000),
    clientSince: new Date(Date.now() - 5 * 24 * 60 * 60 * 1000),
    accountManager: 'Yasmine Alaoui',
    nextAction: 'Qualification des besoins',
    clientType: 'Prospect',
  }
];
